import { useEffect } from "react";
import {
  logCartView,
  logPageView,
  logProductViewedEvent,
} from "@pepdirect/helpers/analyticsLogger";
import {
  LogContextValueInterface,
  Cart,
  Product,
} from "@pepdirect/shared/types";

export function useLogPageProvider(
  currentUserId: string | null
): LogContextValueInterface {
  /**
   * Wrapper for logPageView, so we don't need to
   * write useEffect on every page.
   * @param key some unique id to identify page,
   * for example, page url/slug/whatnot,
   * otherwise it won't trigger when for example
   * route changes from/kit/kit-1 to /kit/kit-2
   * @param pageName some readable page name to send to data layer,
   */
  const useLogPageView = (pageName: string, key?: string): void => {
    useEffect(() => {
      logPageView(currentUserId, pageName);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [key]);
  };

  /**
   * Wrapper for logProductViewedEvent
   * @param product product to log
   */
  const useLogProductViewed = (product: Product | null): void => {
    useEffect(() => {
      logProductViewedEvent(currentUserId, product);
    }, [product]);
  };

  const useLogCartViewed = (cart: Cart | null): void => {
    useEffect(() => {
      if (cart) {
        logCartView(currentUserId, cart);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cart?.id]);
  };

  return { useLogPageView, useLogProductViewed, useLogCartViewed };
}
